export const provincesCode = {
  "Nordrhein-Westfalen": "DE-NW",
  "North Rhine-Westphalia": "DE-NW",
  "Baden-Württemberg": "DE-BW",
  "Baden-Wuerttemberg": "DE-BW",
  "Bayern": "DE-BY",
  "Bavaria": "DE-BY",
  "Berlin": "DE-BE",
  "Brandenburg": "DE-BB",
  "Bremen": "DE-HB",
  "Hamburg": "DE-HH",
  "Hessen": "DE-HE",
  "Hesse": "DE-HE",
  "Mecklenburg-Vorpommern": "DE-MV",
  "Mecklenburg-Western Pomerania": "DE-MV",
  "Niedersachsen": "DE-NI",
  "Lower Saxony": "DE-NI",
  "Rheinland-Pfalz": "DE-RP",
  "Rhineland-Palatinate": "DE-RP",
  "Saarland": "DE-SL",
  "Sachsen": "DE-SN",
  "Saxony": "DE-SN",
  "Sachsen-Anhalt": "DE-ST",
  "Saxony-Anhalt": "DE-ST",
  "Schleswig-Holstein": "DE-SH",
  "Thüringen": "DE-TH",
  "Thuringia": "DE-TH"
};

export const provinces = [
  { code: "DE-BB", name: "Brandenburg" },
  { code: "DE-BE", name: "Berlin" },
  { code: "DE-BW", name: "Baden-Württemberg" },
  { code: "DE-BY", name: "Bayern (Bavaria)" },
  { code: "DE-HB", name: "Bremen" },
  { code: "DE-HE", name: "Hesse (Hessen)" },
  { code: "DE-HH", name: "Hamburg" },
  { code: "DE-MV", name: "Mecklenburg-Vorpommern" },
  { code: "DE-NI", name: "Niedersachsen (Lower Saxony)" },
  { code: "DE-NW", name: "Nordrhein-Westfalen (North Rhine-Westphalia)" },
  { code: "DE-RP", name: "Rheinland-Pfalz (Rhineland-Palatinate)" },
  { code: "DE-SH", name: "Schleswig-Holstein" },
  { code: "DE-SL", name: "Saarland" },
  { code: "DE-SN", name: "Sachsen (Saxony)" },
  { code: "DE-ST", name: "Sachsen-Anhalt (Saxony-Anhalt)" },
  { code: "DE-TH", name: "Thüringen (Thuringia)" },
];

export const provincesSimplified = [
  { code: "DE-BB", name: "Brandenburg" },
  { code: "DE-BE", name: "Berlin" },
  { code: "DE-BW", name: "Baden-Württemberg" },
  { code: "DE-BY", name: "Bayern" },
  { code: "DE-HB", name: "Bremen" },
  { code: "DE-HE", name: "Hesse" },
  { code: "DE-HH", name: "Hamburg" },
  { code: "DE-MV", name: "Mecklenburg-Vorpommern" },
  { code: "DE-NI", name: "Niedersachsen" },
  { code: "DE-NW", name: "Nordrhein-Westfalen" },
  { code: "DE-RP", name: "Rheinland-Pfalz" },
  { code: "DE-SH", name: "Schleswig-Holstein" },
  { code: "DE-SL", name: "Saarland" },
  { code: "DE-SN", name: "Sachsen" },
  { code: "DE-ST", name: "Sachsen-Anhalt" },
  { code: "DE-TH", name: "Thüringen" },
];
